import { render, staticRenderFns } from "./ConfigDetail.vue?vue&type=template&id=55e6e93f&scoped=true&"
import script from "./ConfigDetail.vue?vue&type=script&lang=js&"
export * from "./ConfigDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e6e93f",
  null
  
)

export default component.exports